module.exports = __webpack_public_path__ + "img/uso_geral_android.a15b7719.gif";